import {BackgroundImageSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/backgroundImage'
import {PrimerComponentCardSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCard'
import {PrimerComponentCtaBannerSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCtaBanner'
import {PrimerComponentFaqGroupSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentFaqGroup'
import {PrimerComponentHeroSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentHero'
import {PrimerComponentPillarSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentPillar'
import {PrimerComponentRiverSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentRiver'
import {PrimerComponentRiverBreakoutSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentRiverBreakout'
import {PrimerComponentSectionIntroSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentSectionIntro'
import {PrimerComponentSubnavSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentSubnav'
import {PrimerComponentTestimonialSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentTestimonial'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'

export const TemplateF2Schema = buildEntrySchemaFor('templateF2', {
  fields: z.lazy(() =>
    z.object({
      subnav: safeOptional(PrimerComponentSubnavSchema),
      hero: PrimerComponentHeroSchema,
      heroBackgroundImage: safeOptional(BackgroundImageSchema),
      sectionIntro: safeOptional(PrimerComponentSectionIntroSchema),
      pillars: safeOptional(z.array(PrimerComponentPillarSchema)),
      rivers: z.array(z.union([PrimerComponentRiverSchema, PrimerComponentRiverBreakoutSchema])),
      testimonials: safeOptional(z.array(PrimerComponentTestimonialSchema)),
      ctaBanner: PrimerComponentCtaBannerSchema,
      cardsHeading: z.string().optional(),
      cards: safeOptional(z.array(PrimerComponentCardSchema)),
      faq: safeOptional(PrimerComponentFaqGroupSchema),
    }),
  ),
})
